export const presaleAddress = "0x7e703cfe6918a045e450a0FadC01Aad8Ad894095";
export const tokenAddress = "0x490Bd60a5d3E1207fbA9b699017561434Cc8C675";
export const usdtAddress = "0xdAC17F958D2ee523a2206206994597C13D831ec7";
